import './MagneticCursor.css';

// Simplified cursor for comic theme - just returns null to use default cursor
function MagneticCursor() {
    return null;
}

export default MagneticCursor;
